import { render } from "./CreatePost.vue?vue&type=template&id=2bebb936&scoped=true"
import script from "./CreatePost.vue?vue&type=script&lang=js"
export * from "./CreatePost.vue?vue&type=script&lang=js"

import "./CreatePost.vue?vue&type=style&index=0&id=2bebb936&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b7c0161fc3875e000d6ad7ba26fe3ce3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bebb936"]])

export default __exports__